import React, { useState } from 'react';
import { useMutation, gql } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';
import { theme } from './theme';
import './office_panel.css';

// Paginas publicas de los codigos de validacion (desde el 25/10/2026): /activar para las cuentas empresa nuevas
// (codigo + contraseña de NAWI) y /validar-email para las personas cargadas a mano (codigo).
const ACTIVAR = gql`mutation A($email: String!, $codigo: String!, $password: String!) { activarCuenta(email: $email, codigo: $codigo, password: $password) }`;
const PEDIR = gql`mutation P($email: String!) { pedirCodigoActivacion(email: $email) }`;
const VALIDAR = gql`mutation V($email: String!, $codigo: String!) { validarEmailPersona(email: $email, codigo: $codigo) }`;

const contenedor = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', fontFamily: theme.container.fontFamily, padding: 16, boxSizing: 'border-box' };
const tarjeta = { ...theme.card, maxWidth: '420px', width: '100%', padding: '36px 32px', boxShadow: '0 8px 32px rgba(0,0,0,0.08)', boxSizing: 'border-box' };
const campo = { ...theme.input, width: '100%', boxSizing: 'border-box' };
const etiqueta = { display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '4px', color: '#555' };
const caja = (ok) => ({ padding: '10px 14px', borderRadius: '8px', fontSize: '0.85rem', marginBottom: '12px', lineHeight: 1.45, ...(ok ? { background: '#ecfdf5', color: '#047857', border: '1px solid #a7f3d0' } : { background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' }) });
const mensaje = (e) => e.graphQLErrors?.[0]?.message || e.message;
const soloNumeros = (v) => v.replace(/\D/g, '').slice(0, 6);

function Marco({ icono, titulo, bajada, children }) {
  return (
    <div style={contenedor}>
      <div style={tarjeta}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '36px', marginBottom: '8px' }}>{icono}</div>
          <h2 style={{ ...theme.title, fontSize: '1.3rem', marginBottom: '4px' }}>{titulo}</h2>
          <p style={{ color: '#666', fontSize: '0.9rem', lineHeight: 1.45 }}>{bajada}</p>
        </div>
        {children}
      </div>
    </div>
  );
}

function CampoCodigo({ valor, cambiar }) {
  return (
    <>
      <label style={etiqueta}>Código</label>
      <input inputMode="numeric" autoComplete="one-time-code" maxLength={6} placeholder="123456" value={valor}
        onChange={(e) => cambiar(soloNumeros(e.target.value))} required
        style={{ ...campo, letterSpacing: '6px', fontSize: '1.2rem', textAlign: 'center' }} />
    </>
  );
}

export function Activar() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') || '');
  const [codigo, setCodigo] = useState('');
  const [clave, setClave] = useState('');
  const [clave2, setClave2] = useState('');
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');
  const [listo, setListo] = useState(false);
  const [activar, { loading }] = useMutation(ACTIVAR);
  const [pedir, { loading: pidiendo }] = useMutation(PEDIR);

  const enviar = async (e) => {
    e.preventDefault();
    setError(''); setAviso('');
    if (clave !== clave2) { setError('Las contraseñas no coinciden.'); return; }
    try {
      await activar({ variables: { email: email.trim(), codigo, password: clave } });
      setListo(true);
    } catch (err) { setError(mensaje(err)); }
  };
  const otroCodigo = async () => {
    setError(''); setAviso('');
    if (!email.trim()) { setError('Escribí tu email para mandarte otro código.'); return; }
    try {
      await pedir({ variables: { email: email.trim() } });
      setAviso(`Si ${email.trim()} tiene una cuenta pendiente de activación, le llega un código nuevo en unos minutos.`);
    } catch (err) { setError(mensaje(err)); }
  };

  if (listo) {
    return (
      <Marco icono="✅" titulo="Tu cuenta está activa" bajada="Ya podés entrar a NAWI Chat con tu email y la contraseña que elegiste.">
        <div style={caja(true)}>Cuenta activada: {email.trim()}</div>
      </Marco>
    );
  }
  return (
    <Marco icono="🔑" titulo="Activá tu cuenta de NAWI" bajada="Escribí el código que te llegó por mail y elegí tu contraseña.">
      <form onSubmit={enviar}>
        <label style={etiqueta}>Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@empresa.com" style={campo} required />
        <CampoCodigo valor={codigo} cambiar={setCodigo} />
        <label style={etiqueta}>Contraseña</label>
        <input type="password" value={clave} onChange={(e) => setClave(e.target.value)} placeholder="Mínimo 8 caracteres, con letras y números" style={campo} required minLength={8} autoComplete="new-password" />
        <label style={etiqueta}>Repetir contraseña</label>
        <input type="password" value={clave2} onChange={(e) => setClave2(e.target.value)} style={campo} required autoComplete="new-password" />
        {error && <div style={caja(false)}>{error}</div>}
        {aviso && <div style={caja(true)}>{aviso}</div>}
        <button type="submit" disabled={loading || codigo.length !== 6} style={{ ...theme.button, width: '100%', opacity: loading || codigo.length !== 6 ? 0.6 : 1 }}>{loading ? 'Activando...' : 'Activar cuenta'}</button>
      </form>
      <div style={{ textAlign: 'center', marginTop: '14px' }}>
        <button type="button" onClick={otroCodigo} disabled={pidiendo} style={{ background: 'none', border: 'none', color: '#4f6ef7', cursor: 'pointer', fontSize: '0.85rem' }}>¿Venció o no te llegó? Mandarme otro código</button>
      </div>
    </Marco>
  );
}

export function ValidarEmail() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') || '');
  const [codigo, setCodigo] = useState('');
  const [error, setError] = useState('');
  const [listo, setListo] = useState(false);
  const [validar, { loading }] = useMutation(VALIDAR);

  const enviar = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await validar({ variables: { email: email.trim(), codigo } });
      setListo(true);
    } catch (err) { setError(mensaje(err)); }
  };

  if (listo) {
    return (
      <Marco icono="✅" titulo="Email confirmado" bajada="Gracias: ya quedó confirmado que este email es tuyo. Podés cerrar esta página.">
        <div style={caja(true)}>{email.trim()}</div>
      </Marco>
    );
  }
  return (
    <Marco icono="✉️" titulo="Confirmá tu email" bajada="Escribí el código de 6 números que te llegó por mail. Si venció, pedile otro a quien te registró.">
      <form onSubmit={enviar}>
        <label style={etiqueta}>Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" style={campo} required />
        <CampoCodigo valor={codigo} cambiar={setCodigo} />
        {error && <div style={caja(false)}>{error}</div>}
        <button type="submit" disabled={loading || codigo.length !== 6} style={{ ...theme.button, width: '100%', opacity: loading || codigo.length !== 6 ? 0.6 : 1 }}>{loading ? 'Confirmando...' : 'Confirmar email'}</button>
      </form>
    </Marco>
  );
}
